import { useLayoutEffect, useState } from "react";

export function readRecoveryTokenFromUrl(browserWindow = globalThis.window) {
  if (!browserWindow?.location) return "";
  try {
    const hash = browserWindow.location.hash || "";
    return new URLSearchParams(hash.replace(/^#/, "")).get("token")?.trim() || "";
  } catch {
    return "";
  }
}

export function clearRecoveryFragment(browserWindow = globalThis.window) {
  if (!browserWindow?.location || !browserWindow?.history) return;
  try {
    if (!browserWindow.location.hash) return;
    const cleanUrl = `${browserWindow.location.pathname}${browserWindow.location.search || ""}`;
    browserWindow.history.replaceState(browserWindow.history.state, "", cleanUrl);
  } catch {}
}

export function captureRecoveryTokenFromUrl(browserWindow = globalThis.window) {
  const token = readRecoveryTokenFromUrl(browserWindow);
  clearRecoveryFragment(browserWindow);
  return token;
}

export function useRecoveryTokenFromUrl(browserWindow = globalThis.window) {
  const [token] = useState(() => readRecoveryTokenFromUrl(browserWindow));
  useLayoutEffect(() => {
    clearRecoveryFragment(browserWindow);
  }, [browserWindow]);
  return token;
}

export function recoveryErrorKind(error) {
  if (!error?.response) return "network";
  if ([400, 404, 410, 422].includes(error.response.status)) return "invalid";
  if (error.response.status === 429) return "rate_limit";
  return "network";
}
